
export default class PaymentModel {
    constructor (
        _bank= "",
        _txNumber= "",
        _id = "",
        _file = "",
    ) {
      this.bank   = _bank;
      this.txNumber = _txNumber;
      this.id = _id;
      this.file = _file;
    }
  }
  